import * as Sentry from "@sentry/vue";


export function initLoggingClient(App) {
    Sentry.init({
      App,
      dsn: process.env.VUE_APP_SENTRY_DSN,
      environment: process.env.NODE_ENV,
      sendDefaultPii: true,
      debug: process.env.NODE_ENV === 'production' ? false : true,
    });
}